import { io } from "socket.io-client";
import { config } from "config";

let socketInstance = null;

const Socket = () => {
  if (!socketInstance) {
    const role = localStorage.getItem("role");
    const token = localStorage.getItem("token");

    socketInstance = io(config.socketUrl, {
      transports: ["websocket"],
      withCredentials: true,
      auth: { token, role },
    });

    socketInstance.on("connect", () => {
      console.log("Connected to Socket.IO server");
    });

    socketInstance.on("connect_error", (err) => {
      console.log("Connection error:", err);
    });
  }

  return socketInstance;
};

export default Socket;
